<div class="vendor-analytics" [class.animate-in]="animateIn" *ngIf="vendor">
  <div class="va-loading" *ngIf="loading">Loading analytics…</div>

  <div class="va-grid" *ngIf="!loading">
    <!-- Monthly Sales -->
    <section class="va-card va-sales">
      <h3 class="va-heading">MONTHLY SALES (CURRENT MONTH)</h3>
      <div class="va-sales-body">
        <div class="va-sales-main">
          <div class="va-sales-amount">{{ displayedSales | currency }}</div>
          <div class="va-yoy" [class.up]="yoyPercent >= 0" [class.down]="yoyPercent < 0">
            <span class="va-yoy-arrow">{{ yoyPercent >= 0 ? '▲' : '▼' }}</span>
            {{ yoyPercent | number:'1.0-0' }}%
            <span class="va-yoy-prior">vs {{ priorYearSales | currency }} ({{ selectedYear - 1 }})</span>
          </div>
          <div class="va-days" *ngIf="daysRemaining > 0">
            {{ daysRemaining }} day{{ daysRemaining === 1 ? '' : 's' }} remaining in the month
          </div>
          <div class="va-days muted" *ngIf="daysRemaining === 0">
            Selected period is complete
          </div>
          <div class="va-selectors">
            <mat-form-field appearance="outline" class="va-select">
              <mat-label>Month</mat-label>
              <mat-select [(ngModel)]="selectedMonth" [ngModelOptions]="{standalone: true}" (selectionChange)="onPeriodChange()">
                <mat-option *ngFor="let m of monthOptions" [value]="m.value">{{ m.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="va-select">
              <mat-label>Year</mat-label>
              <mat-select [(ngModel)]="selectedYear" [ngModelOptions]="{standalone: true}" (selectionChange)="onPeriodChange()">
                <mat-option *ngFor="let y of yearOptions" [value]="y">{{ y }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <p class="va-note">Based on vendor invoice totals for the selected month.</p>
        </div>
        <div class="va-radial-wrap">
          <svg class="va-radial" viewBox="0 0 120 120" aria-hidden="true">
            <circle class="va-radial-track" cx="60" cy="60" r="48" />
            <circle
              class="va-radial-progress"
              cx="60" cy="60" r="48"
              [attr.stroke-dasharray]="radialDashArray"
              [attr.stroke-dashoffset]="0"
            />
          </svg>
          <div class="va-radial-label">
            <div class="va-radial-pct">{{ salesProgressPercent | number:'1.0-0' }}%</div>
            <div class="va-radial-sub">vs prior year</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Grade card -->
    <section class="va-card va-grade">
      <div class="va-grade-box">
        <span class="va-grade-letter">{{ overallGrade }}</span>
      </div>
      <div class="va-grade-breakdown">
        <div>FULFILLMENT: <strong>{{ fulfillmentGrade }}</strong></div>
        <div>SELL-THROUGH: <strong>{{ sellThroughGrade }}</strong></div>
      </div>
    </section>

    <!-- Vendor Health -->
    <section class="va-card va-health">
      <h3 class="va-heading">VENDOR HEALTH OVERVIEW</h3>
      <div class="va-health-list">
        <div class="va-health-row" *ngFor="let m of healthMetrics">
          <div class="va-health-meta">
            <span class="va-health-label">{{ m.label }}</span>
            <span class="va-health-value">{{ m.value }}</span>
          </div>
          <div class="va-bar-track">
            <div
              class="va-bar-fill"
              [style.width.%]="animateIn ? m.barPercent : 0"
              [style.background-color]="m.color"
            ></div>
          </div>
        </div>
      </div>
    </section>

    <!-- Inventory Aging -->
    <section class="va-card va-aging">
      <h3 class="va-heading">
        Inventory Aging — {{ vendor.name }}
        <span class="va-sub">({{ framesOnHand }} Frames on Hand)</span>
      </h3>
      <div class="va-aging-body">
        <svg class="va-donut" viewBox="0 0 140 140" aria-hidden="true">
          <circle class="va-donut-track" cx="70" cy="70" r="54" />
          <circle
            *ngFor="let slice of agingSlices"
            class="va-donut-slice"
            cx="70" cy="70" r="54"
            [attr.stroke]="slice.color"
            [attr.stroke-dasharray]="getDashArray(slice)"
            [attr.stroke-dashoffset]="slice.dashOffset"
          />
        </svg>
        <ul class="va-legend">
          <li *ngFor="let slice of agingSlices">
            <span class="va-swatch" [style.background-color]="slice.color"></span>
            <span class="va-legend-label">{{ slice.label }}</span>
            <span class="va-legend-pct">{{ slice.percent | number:'1.0-1' }}%</span>
            <span class="va-legend-count">({{ slice.count }})</span>
          </li>
        </ul>
      </div>
    </section>

    <!-- Shipping performance table -->
    <section class="va-card va-shipping">
      <h3 class="va-heading">Vendor Shipping Performance — Grade Card</h3>
      <div class="va-table-wrap">
        <table class="va-table">
          <thead>
            <tr>
              <th>Vendor</th>
              <th>Avg Fulfillment (days)</th>
              <th>Expected Lead Time (days)</th>
              <th>On-Time %</th>
              <th>Partial %</th>
              <th>Unfulfilled %</th>
              <th>Grade</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ shippingRow.vendorName }}</td>
              <td>{{ shippingRow.avgFulfillmentDays | number:'1.0-1' }}</td>
              <td>{{ shippingRow.expectedLeadTime }}</td>
              <td>{{ shippingRow.onTimePercent | number:'1.0-1' }}%</td>
              <td>{{ shippingRow.partialPercent | number:'1.0-1' }}%</td>
              <td>{{ shippingRow.unfulfilledPercent | number:'1.0-1' }}%</td>
              <td class="va-table-grade">{{ shippingRow.grade }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Overview -->
    <section class="va-card va-overview">
      <h3 class="va-heading va-heading-center">OVERVIEW</h3>
      <div class="va-overview-grid">
        <div class="va-overview-col">
          <div class="va-stat">
            <span class="va-stat-label">Frame Count</span>
            <span class="va-stat-value">{{ overview.frameCount }}</span>
          </div>
          <div class="va-stat">
            <span class="va-stat-label">Awaiting Frames</span>
            <span class="va-stat-value">{{ overview.awaitingFrames }}</span>
          </div>
          <div class="va-stat">
            <span class="va-stat-label">Frame Returns</span>
            <span class="va-stat-value">{{ overview.frameReturns }}</span>
          </div>
        </div>
        <div class="va-overview-col">
          <div class="va-stat">
            <span class="va-stat-label">Frame Value</span>
            <span class="va-stat-value">{{ overview.frameValue | currency }}</span>
          </div>
          <div class="va-stat">
            <span class="va-stat-label">Awaiting Frame Value</span>
            <span class="va-stat-value">{{ overview.awaitingValue | currency }}</span>
          </div>
          <div class="va-stat">
            <span class="va-stat-label">Return Value</span>
            <span class="va-stat-value">{{ overview.returnValue | currency }}</span>
          </div>
        </div>
        <div class="va-overview-col">
          <div class="va-stat">
            <span class="va-stat-label">Retail Value</span>
            <span class="va-stat-value">{{ overview.retailValue | currency }}</span>
          </div>
          <div class="va-stat">
            <span class="va-stat-label">Retail Awaiting</span>
            <span class="va-stat-value">{{ overview.retailAwaiting | currency }}</span>
          </div>
          <div class="va-stat">
            <span class="va-stat-label">Return Loss</span>
            <span class="va-stat-value">{{ overview.returnLoss | currency }}</span>
          </div>
        </div>
      </div>
      <p class="va-note va-note-center">
        Return Loss includes return shipping and credit shortfalls when available; otherwise 0.
      </p>
    </section>
  </div>
</div>
